// removed by extract-text-webpack-plugin
module.exports = {"photo":"CAQo4","overlay":"_3tWXH"};


//////////////////
// WEBPACK FOOTER
// ./app/components/profile-photo/profile-photo.scss
// module id = 1760
// module chunks = 0